export default "__VITE_ASSET__D586BSkN__"